// Copyright (c) Docugami, Inc. All rights reserved.

import { useEffect, useRef, useState } from "react";
import { StorageAccessor } from "utils/StorageAccessor"

export function useBooleanStoredState(key: string, defaultValue?: boolean): [boolean, (arg0: boolean) => void] {
    const storageRef = useRef(new StorageAccessor());
    const [booleanState, setBooleanState] = useState(storageRef.current.getBoolean(key, defaultValue ?? true));

    useEffect(() => {
        if (!!key) {
            storageRef.current.setBoolean(key, booleanState)
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [booleanState]);

    useEffect(() => {
        setBooleanState(storageRef.current.getBoolean(key, defaultValue ?? true));
    }, [key, defaultValue]);

    return [booleanState, setBooleanState];
}
